export enum AddressPartsType {
  State = 'administrative_area_level_1',
  Locality = 'locality',
  City = 'city',
  PostalCode = 'postal_code',
  County = 'administrative_area_level_2',
  StreetNumber = 'street_number',
  StreetName = 'route',
}
